import styled from '../../../config/theme'
import { Link as RouterLink } from 'react-router-dom'
import Text from '../../../components/Text/index'

const Container = styled.div`
  display: flex;
  height: calc(100vh - 200px);

  border-radius: 5px;
  border: 1px solid ${props => props.theme.color.gray};

  position: relative;

  @media screen and (max-width: ${props => props.theme.mediaQueries.home}) {
    border: none;
  }
`

const RoomsContainer = styled.div`
  width: 100%;
  // margin-left: 1px;
  // // border-right: 1px solid ${props => props.theme.color.gray};
  // border-top-left-radius: 5px;
  // border-bottom-left-radius: 5px;
  // display: flex;
  // flex-direction: column;

  // @media screen and (max-width: ${props => props.theme.mediaQueries.home}) {
  //   width: 100%;
  //   border-radius: 5px;
  //   border: 1px solid gray;
  // }
`
const TabsContainer = styled.div`
  width: calc(35% - 1px);
  margin-left: 1px;
  border-right: 1px solid ${props => props.theme.color.gray};
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  @media screen and (max-width: ${props => props.theme.mediaQueries.home}) {
    width: 100%;
    border-radius: 5px;
    border: 1px solid gray;
  }
`
const Content = styled.div`
  border: none;
`

const ChatContainer = styled.div`
  width: calc(70% - 1px);
  background: ${props => props.theme.color.white};

  @media screen and (max-width: ${props => props.theme.mediaQueries.home}) {
    width: calc(100% + 1px);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 5px;

    border: 1px solid ${props => props.theme.color.gray};

    > div:nth-child(2) > div {
      width: calc(100% - 1px);
    }

    > div > div > button:first-child {
      padding: 12px;
    }
  }
`

const Rooms = styled.div`
  overflow: auto;
  border-bottom-left-radius: 5px;

  @media screen and (max-width: ${props => props.theme.mediaQueries.home}) {
    border-bottom-right-radius: 5px;
    width: calc(100% - 2px);
    margin-left: 1px;
    
    > button {
      height: 80px;
    }
  }
`

const Input = styled.input`
  width: 100%;
  margin: 0;
  border: none;
  height: 48px;
  min-height: 48px;
  padding: 0 12px;
  font-size: 16px;
  border-top-left-radius: 5px;
  border-bottom: 1px solid ${props => props.theme.color.gray};

  &::placeholder {
    color: ${props => props.theme.color.placeholder};
    opacity: 1;
  }

  @media screen and (max-width: ${props => props.theme.mediaQueries.home}) {
    border-top-right-radius: 5px;
    width: calc(100% - 2px);
    margin-left: 1px;
  }
`

const ChatTitle = styled(Text)`
  text-overflow: 'ellipsis';
  overflow: 'hidden';
  max-width: 480px;
  white-space: 'nowrap';
  display: 'block';
  margin: 0;

  @media screen and (max-width: 430px) {
    max-width: 140px !important;
  }
  @media screen and (max-width: 320px) {
    max-width: 105px !important;
  }
`

const Room = styled.div<{ selected: boolean, hasUnreadMessages: boolean }>`
  background: ${
  props => props.selected ?
    '#bad8ec' :
    props.hasUnreadMessages ?
      '#ebf6ff' :
      props.theme.color.white
  };
  border: none;
  width: 100%;
  display: flex;
  align-items: center;
  height: 80px;
  cursor: pointer;
  border-bottom: 1px solid ${props => props.theme.color.lightGray};
  outline: none;
  position: relative;

  > img {
    margin-right: 10px;
  }

  > div {
    > * {
      margin: 0;
    }
  }
`

const Status = styled.div<{ online: boolean }>`
  height: 12px;
  width: 12px;

  display: inline-block;

  background: ${props => props.online ? 'limegreen' : 'white'};
  border: 1px solid limegreen;
  border-radius: 12px;

  position: absolute;
  top: 50px;
  left: 40px;
`

const Details = styled.div`
  overflow: hidden;
  flex: 1;

  > h2 {
    white-space: pre;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
    display: block;
  }
`

const LatestMessage = styled.div`
  display: flex;
  align-items: center;

  > span {
    white-space: pre;
    text-overflow: ellipsis;
    overflow: hidden;
    margin: 0 5px;
    display: inline;
    flex: 1;
    text-align: left;
  }

  > img {
    height: 12px;
    width: 12px;
    display: inline-block;
  }
`

const ChatHeader = styled.div`
  padding: 0 10px;
  height: 48px;
  border-bottom: 1px solid ${props => props.theme.color.lightGray};
  box-shadow: 0 2px 6px 0px #00000017;

  position: relative;
  z-index: 1;

  display: flex;
  align-items: center;

  + * {
    margin-top: 5px;
    height: calc(100% - 48px) !important;
  }
`

const Link = styled(RouterLink)`
  display: block;
  text-decoration: none;

  &:hover * {
    color: ${props => props.theme.color.darkBlue};
  }
`

export {
  Container,
  Content,
  RoomsContainer,
  TabsContainer,
  Rooms,
  Input,
  ChatContainer,
  Room,
  Status,
  LatestMessage,
  Details,
  ChatHeader,
  Link,
  ChatTitle,
}
